import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { Box, Button, Stack, Typography } from '@mui/material'

import CheckCircle from '@mui/icons-material/CheckCircle'

import { TLGTypography } from '@components/TLGTypography'

import {
  containerSx,
  contentSx,
  heroLeftSideContentSx,
  heroOverTitleSx,
  heroSubtitleSx,
  heroTitleSx,
  overlaySx,
  subscribeButtonSx,
} from './styles'

const HeroSection = () => {
  const { t } = useTranslation()

  return (
    <Box data-testid="tech-vendors-features-hero-section" sx={containerSx}>
      <Box sx={overlaySx} />
      <Box sx={contentSx}>
        <Stack sx={heroLeftSideContentSx}>
          <Typography variant="h6" sx={heroOverTitleSx}>
            {t('Features')}
          </Typography>
          <TLGTypography
            responsiveVariant={{ xs: 'h5', md: 'h4' }}
            component="h1"
            sx={heroTitleSx}
          >
            {t(
              "Traditional lead generation is obsolete. It's time to embrace a revolutionary approach that guarantees results."
            )}
          </TLGTypography>
          <TLGTypography
            responsiveVariant={{ xs: 'subtitle1', md: 'h6' }}
            sx={heroSubtitleSx}
          >
            <span>
              {t('Welcome to the future of tech marketing and sales.')}
            </span>
            <span>
              {t(
                'Connect with qualified leads actively seeking your solutions and services.'
              )}
            </span>
            <span>{t('Be Discovered by Tech Customers in Buying Mode')}</span>
          </TLGTypography>

          <Button
            data-testid="subscribe-now-button"
            component={RouterLink}
            to="/signup#vendors"
            variant="contained"
            color="secondary"
            size="large"
            endIcon={<CheckCircle />}
            sx={subscribeButtonSx}
          >
            {t('Subscribe Now')}
          </Button>
        </Stack>
      </Box>
    </Box>
  )
}

export { HeroSection }
